import React from "react";

export default function FilterBar({ filters = [], activeFilters = {}, onFilterChange }) {
  if (!filters || filters.length === 0) return null;

  return (
    <div className="flex flex-wrap items-center gap-3 w-full bg-white p-4 rounded-2xl border border-gray-150 shadow-sm mb-6">
      <span className="text-[10px] font-bold text-gray-400 uppercase tracking-wider pl-1 mr-2">
        Filters:
      </span>
      <div className="flex flex-wrap items-center gap-3 flex-grow">
        {filters.map((filter) => {
          const { key, label, options = [] } = filter;
          const currentValue = activeFilters[key] || "All";

          return (
            <div key={key} className="flex flex-col min-w-[120px]">
              <label className="text-[9px] font-bold text-gray-400 uppercase tracking-wide mb-1 ml-0.5">
                {label}
              </label>
              <select
                value={currentValue}
                onChange={(e) => onFilterChange(key, e.target.value)}
                className="w-full px-3 py-2 rounded-xl border border-gray-200 bg-gray-50/50 hover:bg-gray-50 focus:border-[#7C3AED] outline-none text-xs text-gray-700 font-semibold cursor-pointer transition shadow-sm"
              >
                <option value="All">All {label}s</option>
                {options.map((opt) => (
                  <option key={opt} value={opt}>
                    {opt}
                  </option>
                ))}
              </select>
            </div>
          );
        })}
      </div>
    </div>
  );
}
